const Index = () => import("./index.vue");
const List = () => import("./components/List.vue");
const View = () => import("./components/View.vue");

export default [
  {
    path: "inboundDelivery",
    component: Index,
    redirect: { name: "inbound-delivery-list" },
    children: [
      { path: "list", name: "inbound-delivery-list", component: List },
      { path: ":id/view", name: "inbound-delivery-view", component: View },
    ],
  },
];
